import { HE_URL } from '../constants';
import namedReferenceRegex from './namedReferenceRegex';
import htmlEntitiesMap from './htmlEntitiesMap';
import numericEntitiesMap from './numericEntitiesMap';

const ENTITY_START = '&';
const ENTITY_END = ';';

function codePointToSymbol(codePoint) {
  let output = '';

  if (codePoint in numericEntitiesMap) {
    return numericEntitiesMap[codePoint];
  }

  if (codePoint > 0xFFFF) {
    codePoint -= 0x10000;
    output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
    codePoint = 0xDC00 | codePoint & 0x3FF;
  }

  return output + String.fromCharCode(codePoint);
}

function getEntities(str) {
  const result = [];
  let buffer = [];
  let include = false;

  for (const char of str) {
    if (include && char !== ENTITY_END) {
      buffer.push(char);
    }

    if (char === ENTITY_START) {
      include = true;
    }

    if (char === ENTITY_END) {
      result.push(buffer.join(''));
      include = false;
      buffer = [];
    }
  }

  return result;
}

function decode(rawText) {
  if (!rawText) {
    return rawText;
  }

  if (self.he) {
    return self.he.decode(rawText);
  }

  const entities = getEntities(rawText);
  const canConvert = entities.every(entity => entity in htmlEntitiesMap || entity[0] === '#');

  if (canConvert) {
    return rawText.replace(namedReferenceRegex, ($0, $1, $2, $3) => {

      if ($1) {
        return htmlEntitiesMap[$1];
      }

      if ($2) {
        return codePointToSymbol(parseInt($2, 10));
      }

      if ($3) {
        return codePointToSymbol(parseInt($3, 16));
      }

      return $0;
    });
  }

  self.importScripts(HE_URL);

  return decode(rawText);
}

export default decode;
